import { Suspense, useEffect } from 'react'
import { Route, Routes, BrowserRouter, useLocation } from 'react-router-dom'
import { lazy } from 'react'
import PageLayoutLoader from 'components/common/loader/pageLayoutLoader'
import { initGA, logPageView } from 'analytics'
import LoanFlowProtector from './LoanFlowProtector'
import ErrorBoundary from 'components/ErrorBoundary'

//Pages 
const Login = lazy(() => import('../pages/auth/login'))
const FirstTimeLogin = lazy(() => import('pages/auth/firstTimeLogin'))
const ResetPassword = lazy(() => import('pages/auth/reset-password/ResetPassword'))
const SetSecurityQuestions = lazy(() => import('pages/auth/SetSecurityQuestions'))
const IdentifyAccount = lazy(() => import('pages/auth/reset-password/IdentifyAccount'))
const AnswerSecurityQuestions = lazy(() => import('pages/auth/reset-password/AnswerSecurityQuestions'))
const ChooseAccount = lazy(() => import('pages/auth/reset-password/ChooseAccount'))
const SetResetPassword = lazy(() => import('pages/auth/reset-password/SetResetPassword'))
const NewPassword = lazy(() => import('pages/auth/reset-password/NewPassword'))
const DefaultLayout = lazy(() => import('./DefaultLayout'))
const ChangeUsername = lazy(() => import('pages/auth/ChangeUsername'))
const SelfOnBoarding = lazy(() => import('pages/auth/self-onboarding'))
const SelfOnBoardAccountDetails = lazy(() => import('pages/auth/self-onboarding/AccountDetails'))
const SetSafeAccess = lazy(() => import('pages/auth/self-onboarding/SetupSafeAccess'))

const RoutedErrorBoundary = ({ children }: { children: React.ReactNode, }) => {
  const location = useLocation()
  return <ErrorBoundary resetKey={location.pathname}>{children}</ErrorBoundary>
}

const AppLayout = () => {

  useEffect(() => {
    initGA()
    logPageView()
  }, [])

  return(
    <BrowserRouter>
      <RoutedErrorBoundary>
        <LoanFlowProtector />
        <Suspense fallback={<PageLayoutLoader/>}>
          <Routes>
            <Route path='/' element={<Login/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/first-time-login" element={<FirstTimeLogin type="first-time-login" />}/>
            <Route path="/reset-password" element={<ResetPassword />}/>
            <Route path="/reset-password/identify-account" element={<IdentifyAccount />}/>
            <Route path="/reset-password/security-question" element={<AnswerSecurityQuestions />}/>
            <Route path="/reset-password/choose-account" element={<ChooseAccount />}/>
            <Route path="/reset-password/set-credentials" element={<SetResetPassword />}/>
            <Route path="/set-security-questions" element={<SetSecurityQuestions/>}/>
            <Route path="/change-username" element={<ChangeUsername/>}/>
            <Route path="/reset-password/new-password" element={<NewPassword/>}/>
            <Route path='/self-onboarding' element={<SelfOnBoarding/>}/>
            <Route path='/self-onboarding/account-details' element={<SelfOnBoardAccountDetails/>}/>
            <Route path='/self-onboarding/set-credentials' element={<SetSafeAccess/>}/>
            <Route path="*" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </RoutedErrorBoundary>
    </BrowserRouter>
  )
}

export default AppLayout
